/*@ngInject*/
const LoadFieldInstanceListRepository = function (baseRepository, formRegistrationModel) {

    angular.extend(this, baseRepository);

    this.loadFieldInstanceList = function (formId, registrationIdentifier) {
        let url = '/rest/Field/List?formId=' + formId + '&registrationIdentifier=' + registrationIdentifier;

        formRegistrationModel.addRegistration(formId, url);

        return this.get(url);
    };
};

angular.module('umFormViewer')
    .service('loadFieldInstanceListRepository', LoadFieldInstanceListRepository);
